export default class StatsHelper {
  static getSummary(pos, stats, isSeason = false) {
    const summary = [];
    if (pos !== "DEF") {
      if (stats.pass) {
        const { comp, att, yds, td, inter } = stats.pass;
        const elements = [`${comp}/${att}`, `${yds} yds`];
        if (td) elements.push(`${td} TD`);
        if (inter) elements.push(`${inter} INT`);
        summary.push(`${elements.join(", ")}`);
      }
      if (stats.rush) {
        const { att, yds, td } = stats.rush;
        const elements = [`${att} rush`, `${yds} yds`];
        if (td) elements.push(`${td} TD`);
        summary.push(`${elements.join(", ")}`);
      }
      if (stats.rec) {
        const { target, rec, yds, td } = stats.rec;
        const elements = [`${target} targets, ${rec} rec`, `${yds} yds`];
        if (td) elements.push(`${td} TD`);
        summary.push(`${elements.join(", ")}`);
      }
      if (stats.fum) {
        const { lost, td } = stats.fum;
        const elements = [];
        if (lost) elements.push(`${lost} fum lost`);
        if (td) elements.push(`${td} fumble recovered for TD`);
        if (lost || td) summary.push(`${elements.join(", ")}`);
      }
      if (stats.kickRet && stats.kickRet.td) {
        summary.push(`${stats.kickRet.td} kick return TD`);
      }
      if (stats.puntRet && stats.puntRet.td) {
        summary.push(`${stats.puntRet.td} punt return TD`);
      }
      if (stats.kick) {
        const {
          fgNumMade,
          fgNumAtt,
          fgYdsMade,
          fgYdsMissed,
          xptNumMade,
          xptNumAtt,
        } = stats.kick;
        const elements = [];
        if (fgNumAtt) {
          elements.push(`FG: ${fgNumMade}/${fgNumAtt}`);

          if (fgYdsMade?.length) {
            if (isSeason) elements.push(`Long: ${Math.max(...fgYdsMade)}`);
            else elements.push(`Made: ${fgYdsMade.join(",")}`);
          }

          if (fgYdsMissed?.length && !isSeason)
            elements.push(`Missed: ${fgYdsMissed.join(",")}`);
        }
        if (xptNumAtt) {
          elements.push(`XPT: ${xptNumMade}/${xptNumAtt}`);
        }
        if (elements.length) summary.push(elements.join(", "));
      }
    }

    if (pos === "DEF" && stats.def) {
      const { ptsAllow, sacks, inter, fumRec, blocks, safety, twoPoint, td } =
        stats.def;
      const elements = [];
      if (ptsAllow || ptsAllow === 0) elements.push(`${ptsAllow} Pts Allowed`);
      if (sacks) {
        const plural = sacks > 1 ? "s" : "";
        elements.push(`${sacks} Sack${plural}`);
      }
      if (inter) {
        elements.push(`${inter} Int`);
      }
      if (fumRec) {
        elements.push(`${fumRec} Fum Rec`);
      }
      if (blocks) {
        const plural = blocks > 1 ? "s" : "";
        elements.push(`${blocks} Kick${plural} Blocked`);
      }
      if (safety) {
        elements.push(`${safety} ${safety === 1 ? "Safety" : "Safeties"}`);
      }
      if (twoPoint) {
        elements.push(
          `${twoPoint} Def Two-Point Conversion${twoPoint > 1 ? "s" : ""}`
        );
      }
      if (td) {
        elements.push(`${td} Def TD${td > 1 ? "s" : ""}`);
      }

      if (elements.length) summary.push(elements.join(", "));
    }

    return summary;
  }
}
